import type { NskResponse } from "~/models/Api";
import type { WorkflowResourceType } from "~/models/CompanyWorkflowSetting";
import { postRequest } from "~/utils/api/api_handler";
import { generatePath } from "~/utils/generatePath";

export type StartDealWorkflowParams = {
	afterTheFactApproval: boolean;
	comment: string;
	resourceType: WorkflowResourceType;
	workflowDefinitionUuid: string;
};

export const create = async (
	dealId: number,
	params: StartDealWorkflowParams
): Promise<NskResponse<{ workflowUuid: string }>> =>
	postRequest(
		generatePath("/deals/:deal_id/deal_workflows", { deal_id: dealId }),
		{ dealWorkflow: params }
	);
